module.exports = __webpack_public_path__ + "img/FastForward_white.b34318dc.png";